// Packing rules are managed in the Pack Perfect admin app and returned by
// the worker's order-shipment endpoint: the server matches variant/product/
// category rules to the shipment's live items and applies every order-level
// rule to the shipment checklist.
export const PACKING_RULE_TYPE_LABELS = {
  generic: 'Check',
  send_customer_email: 'Email',
  take_picture: 'Photo',
  add_print_item: 'Print item',
  print_shipping_label: 'Shipping label',
  critical_shipping_requirement: 'Critical shipping requirement',
  change_order_status: 'Order status',
};
